module.exports = __webpack_public_path__ + "img/tent-feet.6b94700b.jpg";